import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import { TransactionDirection } from "@bitwarden/web-vault/app/models/enum/transactionDirection";

export function getTransactionAmount(transaction: TransactionView, useNormalized = true): number {
  let transactionAmount = 0;
  if (useNormalized) {
    transactionAmount = Number(transaction.c_valuation.normalizedValue.amount);
  } else {
    transactionAmount = Number(transaction.quantity.actualQuantity.amount);
    if (transaction.direction === TransactionDirection.Out && transactionAmount > 0) {
      transactionAmount = -1 * transactionAmount;
    }
  }

  // TODO(diag): temporary — remove once the Past-view zero-balance source is found.
  // A non-finite amount (NaN / ±Infinity) here poisons the shared cumulative running
  // sum in getBalancesForTransactions, collapsing every later group balance to 0.00.
  // Logs the exact offending transaction + account + symbols so we can trace the source.
  if (!Number.isFinite(transactionAmount)) {
    // eslint-disable-next-line no-console
    console.warn("[BALANCE-NAN-DIAG] non-finite transaction amount", {
      computed: transactionAmount,
      useNormalized,
      transactionId: transaction?.id,
      definition: transaction?.definition,
      accountId: transaction?.accountLink?.id,
      description: transaction?.description,
      postDate: transaction?.postDate,
      direction: transaction?.direction,
      rawNormalizedAmount: transaction?.c_valuation?.normalizedValue?.amount,
      normalizedSymbol: transaction?.c_valuation?.normalizedValue?.symbol,
      rawActualAmount: transaction?.quantity?.actualQuantity?.amount,
      actualSymbol: transaction?.quantity?.actualQuantity?.symbol,
      currency: transaction?.quantity?.currency,
      convrate: transaction?.quantity?.convrate,
      convsym: transaction?.quantity?.convsym,
      valuationPrice: transaction?.valuationPrice,
      bankImportedBalance: transaction?.bankImportedBalance,
    });
  }

  return transactionAmount;
}
